const MainMenuOptionValues = {
  STATS: 'stats',
  TABLE: 'table',
  PLAYERS: 'players',
  LINEUP: 'lineup',
} as const;

export default MainMenuOptionValues;
